import { asScaled } from '../utils';
/* ------- label布局尺寸 start ------- */
const emptyStatusLayout = {
    imgHeight: {
        large: 144,
        medium: 90
    },
    imgWidth: {
        large: 250,
        medium: 156
    },
    maxWidth: {
        large: 200,
        medium: 140
    }
};
const emptyStatusScaled = asScaled(emptyStatusLayout);
export const emptyStatus = {
    scaled: emptyStatusScaled,
    unscaled: emptyStatusLayout
};
